"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var moment = require("moment");

var MomentProvider_1 = require("../../../moment/MomentProvider");

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");

var ValidationResult_1 = require("../ValidationResult");
/**
 * Parses Moment instance from prescribed pattern; see Moment module for more information about patterns.
 *
 * @author Jaroslav Sevcik
 */


var DateParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(DateParser, _Parser_1$Parser);

  function DateParser(pattern) {
    var _this;

    _classCallCheck(this, DateParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateParser).call(this));
    _this.pattern = pattern;
    return _this;
  }
  /**
   * Parses provided value as an instance of Moment.
   * @param input input value
   * @param level desired validation level
   */


  _createClass(DateParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (moment.isMoment(input)) {
        return parserSupport_1.succ(input);
      }

      if (input instanceof Date) {
        // FIXME common-be-fe tests does not support IOC
        var d = typescript_ioc_1.Container.isBound(MomentProvider_1.MomentProvider) ? typescript_ioc_1.Container.get(MomentProvider_1.MomentProvider).fromDate(input).instance : moment(input);

        if (d.isValid()) {
          return parserSupport_1.succ(d);
        }

        return new ValidationResult_1.ValidationError(DateParser.BAD_DATE_INPUT_TYPE_ERROR, input.toISOString());
      }

      if (typeof input !== 'string') {
        return parserSupport_1.badType(input, 'string');
      } // FIXME common-be-fe tests does not support IOC


      var date = typescript_ioc_1.Container.isBound(MomentProvider_1.MomentProvider) ? typescript_ioc_1.Container.get(MomentProvider_1.MomentProvider).fromString(input, this.pattern).instance : moment(input, this.pattern, true);

      if (date.isValid()) {
        return parserSupport_1.succ(date);
      }

      return new ValidationResult_1.ValidationError(DateParser.BAD_DATE_INPUT_TYPE_ERROR, this.pattern);
    }
  }]);

  return DateParser;
}(Parser_1.Parser);

exports.DateParser = DateParser;
DateParser.BAD_DATE_INPUT_TYPE_ERROR = 'BAD_DATE_INPUT_TYPE';
DateParser.ISO_PATTERN = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
DateParser.ISO_PATTERN_SHORT = 'YYYY-MM-DDTHH:mm:ssZ';
DateParser.ISO_PATTERN_CALENDAR_DATE = 'YYYY-MM-DD';
DateParser.UPLOADED_CALENDAR_DATE = 'D.M.YYYY';
DateParser.FILENAME_TIME_PATTERN = 'YYYY-MM-DD-HH-mm-ss';